import { configuration } from "@/lang/pt_BR";
import { createI18n } from "vue-i18n";

const i18n = createI18n({
  legacy: false,
  locale: "pt-br",
  messages: configuration.default,
});

export { i18n };
